import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Facebook from "../assets/facebook.svg";
import Instagram from "../assets/instagram.svg";
import Twitter from "../assets/twitter.svg";
import Youtube from "../assets/youtube.svg";
import desktoplogo from "../assets/desktoplogo.svg";
import locations from "../assets/location.svg";
import phone from "../assets/phone.svg";
import mail from "../assets/mail.svg";
import "./footer.css";
import { getAppSettings, getCategory } from "../api/api";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import newLogo from "../assets/image/Dreamland_logo.webp";
import secondLogo from "../assets/image/dle_logo.webp";

export default function Footer() {
  const navigate = useNavigate();
  const [appSettings, setAppSettings] = useState({});
  const [categories, setCategories] = useState([]);
  const location = useLocation();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const fetchAppSettings = async () => {
    try {
      const response = await getAppSettings();
      if (response.status === 200) {
        setAppSettings(response.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await getCategory();
      if (response.status === 200) {
        setCategories(response.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAppSettings();
    fetchCategories();
  }, []);
  return (
    <>
    <footer className="footer pading150">
      <Container>
        <Row className="mb-4">
          <Col lg={4}>
            <h2 style={{ display: "flex", alignItems: "center", gap: isMobile ? "10px" : "10px" }}>
              <img src={appSettings.footerlogo ? appSettings.footerlogo : (appSettings.logo ? appSettings.logo : newLogo)} alt="logo" style={{ height: isMobile ? "55px" : "60px", objectFit: "contain" }} />
              <div style={{ height: isMobile ? "30px" : "35px", width: "1.5px", backgroundColor: "#0D263C", opacity: "0.2" }}></div>
              <img src={secondLogo} alt="secondary logo" style={{ height: isMobile ? "55px" : "60px", objectFit: "contain" }} />
            </h2>
            <p className=" fw-semibold" style={{ color: "#5A6872", marginTop: "25px", fontSize: "14px" }}>
              Set under a vibrant live stage atmosphere, this concert promises an unforgettable blend of classic hits and contemporary vibes that will keep you singing along all night.
            </p>
            <div className="d-flex align-items-center flex-wrap gap-3 mt-5">
              <div className="d-flex sociallink mt-0">
                <a href="https://www.facebook.com/share/1FdEZdVHNM/" target="_blank" rel="noreferrer">
                  <img src={Facebook} alt="Facebook" />
                </a>
                <a href="https://www.instagram.com/dream_land_entertainment_?igsh=NTFmczFveGVpZG5j" target="_blank" rel="noreferrer">
                  <img src={Instagram} alt="Instagram" />
                </a>
                <a href="https://www.youtube.com/@dreamlandentertainment-26" target="_blank" rel="noreferrer">
                  <img src={Youtube} alt="Youtube" />
                </a>
              </div>
            </div>
          </Col>

          <Col lg={{ span: 3, offset: 1 }} md={6} xs={6} className="mt-4 mt-lg-0">
            <h5 className="mb-3 fs-5 fw-bold text-orange footerlinkheader">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="footerlinks" style={{ cursor: "pointer" }} onClick={() => navigate("/")}>
                <a className="text-decoration-none">Home</a>
              </li>
              <li className="footerlinks" style={{ cursor: "pointer" }} onClick={() => navigate("/event")}>
                <a className="text-decoration-none">Event</a>
              </li>
              <li className="footerlinks" style={{ cursor: "pointer" }} onClick={() => {
                if (location.pathname !== "/") navigate("/");
                setTimeout(() => { const el = document.getElementById("newhome-performers-divider"); if (el) el.scrollIntoView({ behavior: "smooth" }); }, 100);
              }}>
                <a className="text-decoration-none">Performers</a>
              </li>
              <li className="footerlinks" style={{ cursor: "pointer" }} onClick={() => {
                if (location.pathname !== "/") navigate("/");
                setTimeout(() => { const el = document.getElementById("newhome-highlights"); if (el) el.scrollIntoView({ behavior: "smooth" }); }, 100);
              }}>
                <a className="text-decoration-none">Facilities</a>
              </li>

            </ul>
          </Col>

          <Col lg={4} className="mt-4 mt-lg-0">
            <h5 className="text-orange fw-bold fs-5 mb-3">Contact Us</h5>
            <ul className="list-unstyled" style={{ color: "#5A6872" }}>
              <li className="mb-1 fw-semibold footerlinks1" style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                <img src={locations} alt="location" style={{ marginTop: "10px", flexShrink: 0 }} />
                <span>Golden Ground, Sripuram Main Road, Ariyur, Vellore - 632055</span>
              </li>
              <li
                style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "10px" }}
                className="mb-1 fw-semibold footerlinks1"
                onClick={() => window.open("tel:7200027997", "_blank")}
              >
                <img src={phone} alt="phone" style={{ flexShrink: 0 }} /> 
                <span>7200027997</span>
              </li>
              <li
                style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "10px" }}
                className="mb-3 fw-semibold footerlinks1"
                onClick={() => window.open("mailto:dreamlandentertainment26@gmail.com", "_blank")}
              >
                <img src={mail} alt="mail" style={{ flexShrink: 0 }} /> 
                <span style={{ wordBreak: "break-all", fontSize: isMobile ? "12px" : "inherit" }}>dreamlandentertainment26@gmail.com</span>
              </li>
            </ul>
          </Col>
        </Row>

        <Row className="pt-3" style={{ borderTop: "1px solid #EAF0F5" }}>
          <Col xs={12} className="d-flex flex-wrap justify-content-center align-items-center gap-2 py-3">
            <a
              onClick={() => navigate("/termsandcondition")}
              className="footer-policy-btn"
              style={{ cursor: "pointer" }}
            >
              TERMS & CONDITIONS
            </a>
            <span className="footer-policy-dot">•</span>
            <a
              onClick={() => navigate("/refundpolicy")}
              className="footer-policy-btn"
              style={{ cursor: "pointer" }}
            >
              REFUND POLICY
            </a>
            <span className="footer-policy-dot">•</span>
            <a
              onClick={() => navigate("/privacypolicy")}
              className="footer-policy-btn"
              style={{ cursor: "pointer" }}
            >
              PRIVACY POLICY
            </a>
            <span className="footer-policy-dot">•</span>
            <a
              onClick={() => navigate("/cancellationpolicy")}
              className="footer-policy-btn"
              style={{ cursor: "pointer" }}
            >
              CANCELLATION POLICY
            </a>
          </Col>
        </Row>

        <Row className="pt-2">
          <Col xs={12} className="text-center">
            <span style={{ color: "#8F99A2", fontSize: "14px", fontWeight: "500" }}>
              Geetham Sangeetham © 2026. All Rights Reserved.<br />
              <span style={{ fontSize: "12px" }}>Presented By: <strong style={{ color: "#0D263C" }}>DreamLand Entertainment</strong></span>
            </span>
          </Col>
        </Row>
      </Container>
    </footer>

      {/* Floating Get Direction Button - Left Side */}
      <button
        className="floating-direction-btn"
        onClick={() => window.open("https://www.google.com/maps/search/?api=1&query=12.879000,79.107300", "_blank")}
        aria-label="Get Direction"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
        <span className="floating-direction-label">Get Direction</span>
      </button>
    </>
  );
}
